import { Typography } from "antd";
import Paragraph from "antd/lib/typography/Paragraph";
import { theme } from "../../../theme";
import { Li } from "./index.styled";

interface ReservationNoticeInfoProps {}

/**
 * 예약현황 설명 폼
 * @history (240514) 리스트 툴팁으로 이동
 * @returns
 */
export const ReservationNoticeInfo: React.FC<
  ReservationNoticeInfoProps
> = () => {
  return (
    <Paragraph style={{ margin: 0 }}>
      <ul style={{ margin: 0 }}>
        <Li>
          예약신청 : 고객이 결제한 상태로, 장착완료 버튼을 누를 수 없습니다.
        </Li>
        <Li>
          예약확정 : 주문이 확정되어 매장으로 상품이 배송준비중이거나
          배송중입니다.
        </Li>
        <Li>
          <Typography.Text strong style={{ color: theme.colors.mainPrimary3 }}>
            작업완료
          </Typography.Text>
          를 눌러주셔야 정산이 가능합니다.
        </Li>
      </ul>
    </Paragraph>
  );
};
